<template>
  <div class="page-container">
    <TopNavBar v-bind:secondTierLoadingDone="secondTierLoadingDone"/>

    <b-container class="ga-profile-container">
      <div class="ga-profile-layout">
        <aside class="ga-profile-sidebar">
          <div class="ga-profile-card">
            <div class="ga-profile-card__user">
              <i class="fas fa-user-circle" aria-hidden="true"></i>
              <span>{{ $route.params.username }}</span>
            </div>
            <div class="ga-profile-card__karma">
              <span
                :title="$t('Bewertung von anderen Accounts')"
                v-b-tooltip.hover.right
              >Karma</span>
              <span class="ga-profile-card__karma-value">{{ total_likes - total_dislikes }}</span>
            </div>
            <div
              class="ga-profile-card__settings"
              v-if="$route.params.username === getUsername()"
            >
              <h2 class="ga-profile-card__settings-title">{{ $t('Placeholder') }}</h2>
              <label class="ga-profile-radio" for="profile-placeholder-star">
                <input type="radio" name="shortformPlaceholder" id="profile-placeholder-star" value="star" v-model="shortformPlaceholder">
                <span class="ga-profile-radio__box">
                  <span class="ga-profile-radio__label">Gendersternchen</span>
                  <span class="ga-profile-radio__example">Student*in</span>
                </span>
              </label>
              <label class="ga-profile-radio" for="profile-placeholder-colon">
                <input type="radio" name="shortformPlaceholder" id="profile-placeholder-colon" value="colon" v-model="shortformPlaceholder">
                <span class="ga-profile-radio__box">
                  <span class="ga-profile-radio__label">Gender-Doppelpunkt</span>
                  <span class="ga-profile-radio__example">Student:in</span>
                </span>
              </label>
              <label class="ga-profile-radio" for="profile-placeholder-lowdash">
                <input type="radio" name="shortformPlaceholder" id="profile-placeholder-lowdash" value="lowdash" v-model="shortformPlaceholder">
                <span class="ga-profile-radio__box">
                  <span class="ga-profile-radio__label">Gender-Gap</span>
                  <span class="ga-profile-radio__example">Student_in</span>
                </span>
              </label>
              <label class="ga-profile-radio" for="profile-placeholder-slash">
                <input type="radio" name="shortformPlaceholder" id="profile-placeholder-slash" value="slash" v-model="shortformPlaceholder">
                <span class="ga-profile-radio__box">
                  <span class="ga-profile-radio__label">Kurzform</span>
                  <span class="ga-profile-radio__example">Student/-in</span>
                </span>
              </label>
            </div>
          </div>
        </aside>

        <main class="ga-profile-main">
          <List
            :filter-by="$route.params.username"
            :hide-inline-search="true"
            :secondTierLoadingDone="secondTierLoadingDone=true"
            :shortformPlaceholderProfile="shortformPlaceholder"
          />
        </main>
      </div>
    </b-container>
  </div>
</template>

<script>
import TopNavBar from '../../components/TopNavBar'
import List from '../../components/List'
import { ProfileDictionaryEntryService } from '../../services/profileDictionaryEntryService'
var Vue = require('vue')

export default {
  name: 'Profile',
  metaInfo () {
    return {
      title: this.title,
      meta: [
        {
          name: 'description',
          vmid: 'description',
          content: this.description
        },
        {
          property: 'og:title',
          vmid: 'og:title',
          content: this.title
        },
        {
          property: 'og:description',
          vmid: 'og:description',
          content: this.description
        },
        {
          name: 'twitter:title',
          vmid: 'twitter:title',
          content: this.title
        },
        {
          name: 'twitter:description',
          vmid: 'twitter:description',
          content: this.description
        }
      ]
    }
  },
  data () {
    return {
      secondTierLoadingDone: false,
      total_likes: 0,
      total_dislikes: 0,
      error: '',
      shortformPlaceholder: ''
    }
  },
  mounted () {
    this.getUserTermStatistics()
  },
  watch: {
    shortformPlaceholder: function () {
      this.updatePlaceholder()
    }
  },
  computed: {
    title: function () {
      return `${this.$route.params.username} · gender app`
    },
    description: function () {
      return `Dieses Profil hat bis anhin ${this.total_likes - this.total_dislikes} gacks gesammelt.`
    }
  },
  methods: {
    getUsername () {
      return Vue.default.cookie.get('username', 'Profil')
    },
    getUserTermStatistics () {
      ProfileDictionaryEntryService.getProfileDictionaryEntryStatistics(this.$route.params.username)
        .then((response) => {
          this.total_likes = response.data.total_likes
          this.total_dislikes = response.data.total_dislikes
        }).catch((error) => {
          console.log(error)
        })
      ProfileDictionaryEntryService.getProfileDictionaryEntryStatistics(this.getUsername())
        .then((response) => {
          this.shortformPlaceholder = response.data.shortform_placeholder
        }).catch((error) => {
          console.log(error)
        })
    },
    updatePlaceholder () {
      if (this.$route.params.username !== this.getUsername()) return
      ProfileDictionaryEntryService.updatePlaceholder(this.getUsername(), this.shortformPlaceholder)
        .catch((error) => {
          console.log(error)
        })
    }
  },
  components: { List, TopNavBar }
}
</script>
